/**
 * Special Collection Access Control
 * 
 * This script manages the visibility of a hidden "Special Collection" menu item
 * based on URL access parameter and sessionStorage.
 * 
 * Usage: Add ?access=123 to any URL to show the special collection menu item
 * for the current browser session only.
 */

(function() {
    'use strict';
    
    // Configuration - you can modify these values
    const CONFIG = {
        accessParam: 'access',
        accessValue: '123',
        sessionKey: 'special_collection_access',
        menuItemSelector: '.special-collection-menu-item',
        desktopMenuSelector: '#special-collection-desktop',
        mobileMenuSelector: '#special-collection-mobile',
        hiddenClass: 't4s-d-none'
    };
    
    /**
     * Check if the current URL has the special access parameter
     * @returns {boolean} True if access parameter matches expected value
     */
    function hasSpecialAccess() {
        const urlParams = new URLSearchParams(window.location.search);
        return urlParams.get(CONFIG.accessParam) === CONFIG.accessValue;
    }
    
    /**
     * Set the special access flag in sessionStorage
     */
    function setSpecialAccess() {
        try {
            sessionStorage.setItem(CONFIG.sessionKey, 'true');
        } catch (e) {
            console.warn('Could not set sessionStorage:', e);
        }
    }
    
    /**
     * Check if special access is stored in sessionStorage
     * @returns {boolean} True if access is stored
     */
    function hasStoredAccess() {
        try {
            return sessionStorage.getItem(CONFIG.sessionKey) === 'true';
        } catch (e) {
            console.warn('Could not read sessionStorage:', e);
            return false;
        }
    }
    
    /**
     * Show the special collection menu items
     */
    function showSpecialCollection() {
        // Show all menu items with the class
        const menuItems = document.querySelectorAll(CONFIG.menuItemSelector);
        menuItems.forEach(function(item) {
            item.classList.remove(CONFIG.hiddenClass);
        });
        
        // Also specifically target desktop and mobile menu items by ID
        const desktopMenu = document.querySelector(CONFIG.desktopMenuSelector);
        if (desktopMenu) {
            desktopMenu.classList.remove(CONFIG.hiddenClass);
        }
        
        const mobileMenu = document.querySelector(CONFIG.mobileMenuSelector);
        if (mobileMenu) {
            mobileMenu.classList.remove(CONFIG.hiddenClass);
        }
    }
    
    /**
     * Hide the special collection menu items
     */
    function hideSpecialCollection() {
        // Hide all menu items with the class
        const menuItems = document.querySelectorAll(CONFIG.menuItemSelector);
        menuItems.forEach(function(item) {
            item.classList.add(CONFIG.hiddenClass);
        });
        
        // Also specifically target desktop and mobile menu items by ID
        const desktopMenu = document.querySelector(CONFIG.desktopMenuSelector);
        if (desktopMenu) {
            desktopMenu.classList.add(CONFIG.hiddenClass);
        }
        
        const mobileMenu = document.querySelector(CONFIG.mobileMenuSelector);
        if (mobileMenu) {
            mobileMenu.classList.add(CONFIG.hiddenClass);
        }
    }
    
    /**
     * Initialize the special collection access control
     */
    function initSpecialCollectionAccess() {
        console.log('Special Collection Access: Initializing...');
        console.log('URL Access:', hasSpecialAccess());
        console.log('Stored Access:', hasStoredAccess());
        
        // Check if user has access via URL parameter
        if (hasSpecialAccess()) {
            console.log('Special Collection Access: URL access granted, setting session and showing menu');
            setSpecialAccess();
            showSpecialCollection();
            
            // Optional: Clean up URL by removing the access parameter
            // Uncomment the following lines if you want to remove the parameter from URL
            /*
            const url = new URL(window.location);
            url.searchParams.delete(CONFIG.accessParam);
            window.history.replaceState({}, document.title, url);
            */
        } 
        // Check if user has stored access from previous visit
        else if (hasStoredAccess()) {
            console.log('Special Collection Access: Session access granted, showing menu');
            showSpecialCollection();
        } 
        // No access - hide the menu items
        else {
            console.log('Special Collection Access: No access, hiding menu');
            hideSpecialCollection();
        }
    }
    
    /**
     * Handle page navigation (for SPA-like behavior)
     */
    function handleNavigation() {
        // Re-check access on page changes
        if (hasStoredAccess()) {
            showSpecialCollection();
        } else {
            hideSpecialCollection();
        }
    }
    
    // Initialize when DOM is ready
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', initSpecialCollectionAccess);
    } else {
        initSpecialCollectionAccess();
    }
    
    // Handle navigation events (for themes that use AJAX navigation)
    window.addEventListener('popstate', handleNavigation);
    
    // Optional: Handle form submissions and link clicks
    document.addEventListener('click', function(e) {
        const link = e.target.closest('a');
        if (link && link.href && !link.href.includes('#')) {
            // Small delay to allow navigation to complete
            setTimeout(handleNavigation, 100);
        }
    });
    
    // Expose functions globally for debugging (optional)
    window.SpecialCollectionAccess = {
        show: showSpecialCollection,
        hide: hideSpecialCollection,
        hasAccess: hasStoredAccess,
        config: CONFIG
    };
    
})();
